import {BASE_URL} from 'appConstants';

import {get} from 'sdk';

export const fetchOccupancyReportForPeriod = ({
  locationRef,
  periodStart,
  periodEnd,
  resolution
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/occupancy/period-report/`;

  const params = {periodStart, periodEnd, resolution};

  return get(url, params);
};

export const fetchLiveAvailability = ({locationRef}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/occupancy/live-availability/`;

  return get(url);
};

export const exportOccupancyReport = ({
  locationRef,
  periodStart,
  periodEnd,
  resolution
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/occupancy/period-report/export/`;

  const params = {periodStart, periodEnd, resolution};

  return get(url, params);
};

export const fetchOccupancyReportForRoomPurposes = ({
  locationRef,
  periodStart,
  periodEnd,
  resolution
}) => {
  const url = `${BASE_URL}/v1/reporting/${locationRef}/occupancy/room-purposes-period-report/`;

  const params = {periodStart, periodEnd, resolution};

  return get(url, params);
};
